<template>
  <hr class="horizontal" style="margin: 8px 0" v-if="selectedOption" />

  <div
    class="d-flex-column justify-start align-start gap-18"
    v-if="selectedOption"
  >
    <div class="d-flex-column justify-start align-start gap-5">
      <div class="d-flex-row justify-start gap-5">
        <label class="t-white font-family-1 regular-l f-w-600">
          {{ $t("calculators_common.ow-boost.preferredChamps") }}
        </label>
      </div>

      <div
        class="cart_option_container b-radius-6 cursor-pointer"
        @click.stop="toggleOpen"
        v-click-outside="closeOpen"
      >
        <div class="d-flex-row flex-8 justify-start">
          <p
            class="t-grey font-family-2 white-space-no regular-l"
            style="text-overflow: ellipsis; max-width: 25ch; overflow: hidden"
          >
            {{ selectedOptions }}
          </p>
        </div>
        <ChevDown />

        <Transition name="slide-fade-top">
          <div class="divisions_list_container" v-if="isOpen">
            <div
              class="item"
              v-for="option in filteredChamps"
              :key="option"
              :class="[isSelected(option.id) && 'active_item']"
              @click.stop="selectChampion(option.id)"
            >
              <div class="d-flex-row justify-start">
                <img
                  :src="option.image"
                  class="hero_image"
                  alt="hero_image"
                  height="30"
                  width="30"
                />
                <p class="font-family-2 regular-l t-white">
                  {{ option.title }}
                </p>
              </div>
            </div>
          </div>
        </Transition>
      </div>
    </div>
  </div>
</template>

<script setup>
import ItemTooltip from "../../fc-25/pickers/ItemTooltip.vue";
import Checkbox from "~/components/custom/Checkbox.vue";
import ChevDown from "~/components/icons/ChevDown.vue";
import { calculateCurrency } from "~/calculate/calculatePrice";
import { eventBus } from "~/lib/eventBus";
const isOpen = ref(false);
const gameStore = useGameStore();

const toggleOpen = () => {
  isOpen.value = !isOpen.value;
  eventBus.emit("closeAll");
  eventBus.emit("closeCartOption");
};

const closeOpen = () => {
  if (isOpen.value) {
    isOpen.value = false;
  }
};

const emit = defineEmits(["closeParentDrop"]);

const { getUserCurrency } = useUserStore();
const checkoutStore = useCheckoutStore();
const { currentGameSlug } = useGameComposable();

const switchClick = (option) => {
  // selectOption(option);
};

const filteredChamps = computed(() => {
  return gameStore.getGameHeroes.sort((a, b) => a.title.localeCompare(b.title));
});

const selectedOption = computed(() => {
  if (
    gameStore.getGamePack.slug === "league-of-legends-mastery-boost" ||
    gameStore.getGamePack.slug === "dota-2-win-rate-boosting"
  ) {
    return true;
  }
  const options = gameStore.getGamePack.pack_options;
  const selectedOptions = options.filter((option) =>
    checkoutStore.getPackOptions.includes(option.id)
  );
  const isSpecChampionSelected = selectedOptions.findIndex(
    (option) =>
      [
        "Spec Champions",
        "Agents Preferences",
        "Specific Operators",
        "Specific Heroes",
        "Specific Champions",
        "Specific Agents",
        "Roles Preferences",
        "Specific Heroes & Roles",
        "Specific Legends",
        "Champions Preferences",
        "preferred_heroes",
      ].includes(option.title) ||
      [
        "Spec Champions",
        "Agents Preferences",
        "Specific Operators",
        "Specific Heroes",
        "Specific Champions",
        "Specific Agents",
        "Roles Preferences",
        "Specific Heroes & Roles",
        "Specific Legends",
        "Champions Preferences",
        "preferred_heroes",
      ].includes(option.const_title)
  );
  return isSpecChampionSelected >= 0;
});

watch(selectedOption, (newVal) => {
  if (newVal) {
    gameStore.apiGetGameHeroes({
      gameSlug: currentGameSlug,
    });
  } else {
    checkoutStore.clearHeroes();
  }
});

const selectChampion = (championId) => {
  checkoutStore.setHero({
    championId,
  });
};
const isSelected = (champion) => {
  return checkoutStore.getSelectedHeros.includes(champion);
};
const selectedOptions = computed(() => {
  const options = filteredChamps.value
    ?.filter((op) => checkoutStore.getSelectedHeros.includes(op.id))
    ?.map((op) => op.title)
    ?.join(", ");

  return options;
});
</script>

<style lang="scss">
.cart_option_container {
  display: flex;
  height: 40px;
  padding: 0px 12px;
  justify-content: space-between;
  align-items: center;
  gap: 11px;
  flex-shrink: 0;
  align-self: stretch;
  border: 1px solid var(--Stroke-Medium, #27292b);
  background: var(--BG-Medium, #121314);
  position: relative;
  .divisions_list_container {
    position: absolute;
    top: 105%;
    left: 0%;
    width: 100%;
    height: max-content;
    max-height: 30vh;
    overflow: auto;
    background-color: var(--bg-medium);
    border: 1px solid var(--stroke-medium);
    z-index: 9999;
    border-radius: 3px;
    -moz-border-radius: 3px;
    -webkit-border-radius: 3px;
    padding: 6px;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    flex-direction: column;
    z-index: 10;
    gap: 6px;
    .item {
      width: 100%;
      height: 48px;
      outline: none;
      border: none;
      text-align: start;
      padding: 11px;
      border-radius: 3px;
      -moz-border-radius: 3px;
      -webkit-border-radius: 3px;
      cursor: pointer;
      display: flex;
      justify-content: space-between;
      align-items: center;
      gap: 0px;
      z-index: 1;
      @media screen and (max-width: 480px) {
        padding: 16px;
      }

      &.active_item,
      &:hover {
        background-color: var(--bg-main);
        color: var(--white);
      }
    }
  }
}
</style>
